export default __webpack_public_path__ + "static/media/LogoCol.6d210a50.svg";